import BaseComponent from "../components/BaseComponent";
import {Panel, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import MainMenu from "../components/MainMenu";
import StandCollectionsList from "../references/standcollections/List";
import StandCollectionForm from "../references/standcollections/Form";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import StandCollectionsApi from "../api/references/standcollections";
import {OfflineProvider} from "../contexts/OfflineContext";

class FragmentStandCollections extends BaseComponent {

    constructor(props) {
        super(props)
        const state = {

            activePanelBrandsCollections: "panel_brandscollections_list",
            current_brandcollection: null,
            returnStory: null,
            getImageEventName: "setImage",

            // Сохраняем состояние списка коллекций при переключении панелей
            listState: null,
        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    // Callback для сохранения состояния списка
    saveListState = (listState) => {
        this.setState({ listState })
    }

    receiveMessage = (event) => {
        if (event.data.type !== undefined && event.data.type === 'setCurrentBrandCollection') {
            const value = event.data.value
            this.setState({
                current_brandcollection: value,
                activePanelBrandsCollections: value !== null ? 'panel_brandscollections_item' : 'panel_brandscollections_list',
                returnStory: value !== null ? (event.data.returnStory || null) : this.state.returnStory,
            })
            return
        }
        if (event.data.type !== undefined && event.data.type === 'reloadCurrentBrandCollection' && this.state.current_brandcollection.id > 0) {
            StandCollectionsApi.getOne(this.state.current_brandcollection.id).then(response => {
                const {data} = response

                if (data.id) {
                    this.setState({
                        current_brandcollection: data,
                        activePanelBrandsCollections: 'panel_brandscollections_item'
                    })
                }
            })

            return
        }
    }

    hideCollectionForm = () => {
        const returnStory = this.state.returnStory
        this.setState({
            current_brandcollection: null,
            activePanelBrandsCollections: 'panel_brandscollections_list',
            returnStory: null,
        })
        if (returnStory && this.props.setActiveStory) {
            this.props.setActiveStory(returnStory)
            try {
                window.history.pushState(null, null, this.state.url + '/' + returnStory.replace(/_story$/, ''))
            } catch (e) {}
        }
    }

    render() {
        return <OfflineProvider>
            <View activePanel={this.state.activePanelBrandsCollections}>
                <Panel id="panel_brandscollections_list">
                    <SplitLayout>
                        {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                        <SplitCol>
                            <StandCollectionsList 
                                current_user={this.props.current_user}
                                savedListState={this.state.listState}
                                onSaveListState={this.saveListState}
                            />
                        </SplitCol>
                        {!AdaptivityContext.isMobile &&
                            <SplitCol>

                            </SplitCol>}
                    </SplitLayout>
                </Panel>
                <Panel id="panel_brandscollections_item">
                    <SplitLayout>
                        {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                        <SplitCol>
                            <StandCollectionForm
                                current_user={this.props.current_user}
                                item={this.state.current_brandcollection}
                                base_url={this.state.base_url}
                                eventType="setCurrentBrandCollection"
                                title_new="Новая коллекция"
                                title="Коллекция"
                                fields={
                                    {
                                        title: {
                                            required: true,
                                            title: 'Наименование',
                                            type: 'text'
                                        },
                                        deleted: {
                                            title: 'Запрет ввода',
                                            type: 'checkbox'
                                        },

                                    }
                                }
                                hideForm={this.hideCollectionForm}

                            />
                        </SplitCol>
                        {!AdaptivityContext.isMobile && <SplitCol>
                        </SplitCol>}
                    </SplitLayout>
                </Panel>

            </View>
        </OfflineProvider>
    }
}

export default FragmentStandCollections